module.exports = __webpack_public_path__ + "media/img/ms-icon-150x150-8272aeeca2bbccecc02bf2af58d94389.png";